import type { NextPage } from 'next'
import styles from '../styles/About.module.scss'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { Col, Image, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'

const About: NextPage = () => {

	const contactList = [
		{
			icon: faMapMarkerAlt,
			text: '12 Woodlands Square, Woods Square Tower 1, #04-78 Singapore 737715',
		},
		{
			icon: faEnvelope,
			text: 'sales@findjobs.com.sg',
		}
	]

	return (
		<>
			<div className={styles.about}>
				<Row className='p-3'>
					<Col lg={5} xs={12} className='d-none d-lg-block p-4'>
						<Image width='100%' src='/img/Hero_multilanguages-1024x854.png' alt='Multiple Language' />
					</Col>
					<Col lg={7} xs={12}>
						<Image src='/img/findjobs-logo.png' width="50%" alt='findjobs-logo' />
						<Image src='/img/business-for-good.PNG' width="50%" alt='business-for-good' />
						<p className={styles.desc}>Findjobs, a member of The Singapore Centre for Social Enterprise (raiSE) develops mobile apps in different languages to connect jobs to non-executive jobseekers effectively. Together with NTUC’s e2i (Employment and Employability Institute), Findjobs also developed and piloted a smart job kiosk to assist offline resident jobseekers who do not have a smartphone or data plan to access easily to nearby job opportunities. We believe strongly in delivering jobs to the community in order to meet the needs of individuals, and strive in connecting offline jobseekers and online employers together.</p>
						<Row className={styles.getInTouch}>
							<Col>
								<h3 className={styles.aboutTitle}>Get In Touch</h3>
							</Col>
						</Row>
						<Row>
							<Col lg={7} xs={12}>
								<iframe src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7977.591048716865!2d103.786321!3d1.297373!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5bc0ec89fb94563a!2sFindjobs%20Pte%20Ltd!5e0!3m2!1sen!2ssg!4v1631175371352!5m2!1sen!2ssg' width='100%' height='250' style={{ border: '0' }} allowFullScreen={false} loading='lazy' className={styles.map} />
							</Col>
							<Col lg={5} xs={12}>
								{
									contactList.map((data, i) => (
										<Row className={styles.contact} key={i}>
											<Col xs={1}>
												<FontAwesomeIcon width='16px' icon={data.icon} />
											</Col>
											<Col xs={10}>
												<span>{data.text}</span>
											</Col>
										</Row>
									))
								}
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		</>
	)
}

export async function getStaticProps({ locale }) {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common']))
			// Will be passed to the page component as props
		}
	}
}

export default About
